import { HTTP } from '../../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';
import { ChangeLessee } from '../../../models/ChangeLessee';

export const { mapFields: mapLesseeFields } = createHelpers({
  getterType: `changeLessee/getField`,
  mutationType: `changeLessee/updateField`,
});

const state = {
  lesseeApplication: new ChangeLessee(),
  newCustomer: {},
  formerCustomer: {},
  processingChangeOfLesse: false,
  createOnly: false,
};
const getters = {
  getField,
  message: (state) => state.message,
  processingChangeOfLesse: (state) => state.processingChangeOfLesse,
  formerCustomer: (state) => state.formerCustomer,
  createOnly: (state) => state.createOnly,
};
const mutations = {
  setCreateOnly: (state, data) => {
    state.createOnly = data;
  },
  setLesseeApplication(state, application) {
    state.lesseeApplication = application;
  },
  setProgress(state, message) {
    state.message = message;
  },
  updateField,
  setNewCustomer(state, data) {
    state.newCustomer = data;
  },
  setFormerCustomer(state, data) {
    state.formerCustomer = data;
  },
  setProcessingChangeOfLesse(state, data) {
    state.processingChangeOfLesse = data;
  },
};

//ACTIONS
const actions = {
  assignNewCustomer({ commit }, data) {
    commit('setNewCustomer', data);
  },
  assignFormerCustomer({ commit }, data) {
    commit('setFormerCustomer', data);
  },
  reset({ commit }) {
    commit('setLesseeApplication', new ChangeLessee());
  },
  async createLesse({ dispatch, commit }, data) {
    commit('setProgress', new httpError());
    data = JSON.parse(JSON.stringify(data));

    try {
      let response = await HTTP.post(`order/ProcessChangeLessee`, data);
      dispatch(
        'setMessage',
        new httpError({
          message: 'Change of Lesse Proceess is now in progress',
          httpStatus: 200,
        })
      );
      return Promise.resolve(response);
    } catch (e) {
      dispatch(
        'setMessage',
        new httpError({
          message:
            'Error in getting change of lessee application : ' +
            err.response.statusText,
          httpStatus: 500,
        })
      );
    }
  },
  getLesseeApplication({ dispatch, rootState }, guid) {
    let request = '';
    if (guid) {
      request = HTTP.get('order/GetChangeLesseeFromGuid/' + guid);
    } else {
      let orderID = rootState.orders.rows[0].orderID;
      request = HTTP.get('order/GetChangeLessee/' + orderID);
    }

    return new Promise((resolve, reject) => {
      request
        .then(function (data) {
          if (data.status == 200) resolve(data.data);
          else reject('No Content');
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message:
                'Error in getting change of lessee application : ' +
                err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  updateLesseeApplication({ dispatch, commit }, application) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/UpdateChangeLessee/', application);
      response
        .then((data) => {
          commit('setLesseeApplication', data.data);
          dispatch(
            'setMessage',
            new httpError({
              message: 'Application for Change of Lessee saved',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message:
                'Application for Change of Lessee failed : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  approveChangeLessee({ dispatch }, form) {
    let call = '';

    if (form.isNewCustomer) call = 'Order/ApproveChangeNewLessee/';
    else call = 'Order/ApproveChangeFormerLessee/' + form.sms;

    return new Promise((resolve, reject) => {
      var response = HTTP.post(call, form.lesseeApplication);
      response
        .then(() => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Approval for Change of Lessee sent',
              httpStatus: 200,
            })
          );
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Sending failed : ' + err.message,
              httpStatus: 500,
            })
          );
          reject();
        });
    });
  },
  rejectChangeLessee({ dispatch }, application) {
    return new Promise((resolve, reject) => {
      var response = HTTP.post('Order/RejectChangeLessee/', application);
      response
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Rejection notice sent.',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Sending failed : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  dispatchChangeLessee({ dispatch }, form) {
    let call = '';
    if (form.isSMS) call = 'Order/SendChangeLesseeSMStoCustomer/';
    else call = 'Order/SendChangeLesseeEmailtoCustomer/';

    return new Promise((resolve, reject) => {
      HTTP.post(call, form.lesseeApplication)
        .then((data) => {
          dispatch(
            'setMessage',
            new httpError({
              message:
                'Application for Change Lessee SMS sent to original customer',
              httpStatus: 200,
            })
          );
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Sending failed : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  getTermsForLessee({ dispatch }, application) {
    return new Promise((resolve, reject) => {
      let request = HTTP.get('order/GetTerms/' + application.orderID);
      request
        .then(function (data) {
          if (data.status == 200) resolve(data.data);
          else reject('No Content');
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message:
                'Error in getting terms for change of lessee application : ' +
                err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  populate({ dispatch }, payload) {
    return new Promise((resolve, reject) => {
      if (typeof payload.application == 'undefined') {
        reject('no data available');
        return;
      }
      let request = {
        template: {
          name: 'ChangeLessee',
          recipe: payload.isPDF ? 'chrome-pdf' : 'phantom-image',
          engine: 'handlebars',
          waitForJS: true,
        },
        data: payload.application,
      };

      HTTP.post('Report/Generate', request, { responseType: 'arraybuffer' })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: payload.isPDF ? 'application/pdf' : 'image/png',
          });

          resolve(blob);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
